module.exports = __webpack_public_path__ + "38230844fda619d2a6b3f70348a9a00a.svg";